import { Component, ElementRef, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-nested-widget',
  templateUrl: './nested-widget.component.html',
  styleUrls: ['./nested-widget.component.scss']
})
export class NestedWidgetComponent implements OnInit, OnDestroy {
  static key = 100807;

  @ViewChild("nestedwidget", { static: true }) nestedwidget!: ElementRef;
  @Input("item") item: any;
  @Input("height") height: any;
  @Input("data") data: any;
  @Input("pageKey") pageKey: any;

  widgetItems: any[] = [];
  items: any;

  @HostBinding("class.is-fullscreen") isFullscreen = false;
  @ViewChild("fs") fs!: ElementRef;

  @Output("onSizeChange") onSizeChange = new EventEmitter<number>();

  isActive: boolean = false;
  isLoading: boolean = true;
  noData: boolean = false;
  reqSubcription: Subscription[] = [];

  constructor(private filterService: FilterService) {
    this.reqSubcription.push(
      this.filterService.chartshowBy.subscribe((res: any) => {
        const widgetKey = res?.item?.widget_uniq_key || 100807;
        if (widgetKey == this.item.widget_uniq_key) {
          this.isLoading = true;
          this.changeChart(res.value);
        }
      })
    );
  }

  ngOnInit(): void {
    this.widgetItems = this.item?.["nested_widget_config"] || [];

    // Merge header config if needed
    const config = this.item.config?.widget_header_config;
    const add_header = config?.filter((f: any) => f.add_header) || [];

    if (add_header.length > 0 && this.widgetItems.length > 0) {
      this.widgetItems.forEach((res: any) => {
        res['widget_uniq_key'] = this.item?.widget_uniq_key || '';
        add_header.forEach((a: any) => {
          if (res?.config?.widget_header_config) {
            const idx = res.config.widget_header_config.findIndex((f: any) => f.value === a.value);
            if (idx !== -1) {
              res.config.widget_header_config[idx] = { ...a };
            }
          } else if (res?.config?.widget_header_configuration) {
            const idx = res.config.widget_header_configuration.findIndex((f: any) => f.value === a.value);
            if (idx !== -1) {
              res.config.widget_header_configuration[idx] = { ...a };
            }
          }
        });
      });
    }

    // 🔑 Load saved user state or fallback to default
    const widgetKey = this.item.widget_uniq_key || 'default';
    const savedIndex = this.filterService.getNestedWidgetIndex(widgetKey);

    const fallbackIndex = Number(
      this.item?.config?.widget_header_config?.[0]?.show_by_value?.[0]?.value ?? this.item?.config?.widget_header_config?.[0]?.selection_toggle?.[0]?.value ?? 0 
    );

    const initialIndex = savedIndex !== undefined ? savedIndex : fallbackIndex;

    this.items = this.widgetItems[initialIndex] || this.widgetItems[0];

    // Setup resize observer
    const observer = new ResizeObserver((entries) => {
      this.onSizeChange.emit(entries[0].contentRect.height);
    });
    observer.observe(this.nestedwidget.nativeElement);
  }

  fullscreenChanges(fullscreen: boolean): void {
    this.isFullscreen = fullscreen;
    this.isActive = fullscreen;
  }

  sizeEmit(): void {
    // Placeholder if needed
  }

  changeChart(index: any): void {
    const numIndex = Number(index);
    this.items = this.widgetItems[numIndex];

    // 🔑 Save user's selection
    const widgetKey = this.item.widget_uniq_key || 'default';
    this.filterService.setNestedWidgetIndex(widgetKey, numIndex);

    setTimeout(() => {
      this.filterService.triggerNestedQuery.next(this.item.widget_uniq_key);
    }, 2000);
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach(sub => sub.unsubscribe());
  }
}